import { reduxForm } from 'redux-form';
import { push } from 'react-router-redux/lib/actions';
import validateTool from 'validate.js';
import EventsEditForm from './EventsEditForm';
import { EVENTS_ROUTER_ROOT } from '../constants'
import CRUDAction from '../../../actions/event';
import Event from '../../../api/event';
import BingoVoting from '../../../api/voting/bingo';
import MatchResultVoting from '../../../api/voting/matchResult';
import BestPlayerVoting from '../../../api/voting/bestPlayer';
import { convertDate } from './votings/helper';
import { getVotesConfig } from 'components/Events/EventsEditForm/votings/votingConfig';

const validate = (data) => {
  return Object.assign(
    validateTool(data, Event.validateConstraints) || {},
    data.hasBingoVoting ? { bingoVoting : validateTool(data.bingoVoting || {}, BingoVoting.validateConstraints) } : {},
    data.hasMatchResultVoting ? { matchResultVoting : validateTool(data.matchResultVoting || {}, MatchResultVoting.validateConstraints) } : {},
    data.hasBestPlayerVoting ? { bestPlayerVoting : validateTool(data.bestPlayerVoting || {}, BestPlayerVoting.validateConstraints) } : {}
  );
};

export default reduxForm(
  {
    form: 'events_edit_form',
    fields: ['first_partc', 'second_partc', 'start_time', 'end_time',
      // match result voting
      'matchResultVoting.voting',
      'matchResultVoting.start_time',
      'matchResultVoting.end_time',

      // best player voting
      'bestPlayerVoting.voting',
      'bestPlayerVoting.players',
      'bestPlayerVoting.start_time',
      'bestPlayerVoting.end_time',

      // bingo voting
      'bingoVoting.voting',
      'bingoVoting.file',
      'bingoVoting.award_info',
      'bingoVoting.award_location',
      'bingoVoting.award_expire_date',
      'bingoVoting.start_time',
      'bingoVoting.end_time'
    ],
    returnRejectedSubmitPromise: true,
    validate
  },
  ( { event : { model = null, loadingItem}, auth: { user: { club } } } ) => ({
    model,
    loading: loadingItem,
    ...getVotesConfig(club.id),
    isAbleToDelete: model && !model.isNew(),
    initialValues: Object.assign({}, model, model ? {
      start_time: convertDate(model.start_time),
      end_time: convertDate(model.end_time),
      first_partc: convertParticipant(model.first_partc),
      second_partc: convertParticipant(model.second_partc)
    } : {})
  }),
  dispatch => ({
    publish: (model) => dispatch(CRUDAction.publish(model)),
    announceResult: (model) => dispatch(CRUDAction.announceResult(model)),
    save: (data) => dispatch(CRUDAction.save(data)),
    onClose: () => dispatch(CRUDAction.onCloseEditForm()),
    goIndex: () => dispatch(push(EVENTS_ROUTER_ROOT))
  }),
)(EventsEditForm);

function convertParticipant(participant) {
  return participant ? participant.id : undefined
}




// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/index.js